<template>
  <div>
    <v-row
      dense
    >
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMRP"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + '10'"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.RSRPDR"
            outlined
            dense
            :label="$t('training_builder.text_input.rest_between_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + 30"
            suffix="s"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="6">
        <minute-second-input
          :value="dirtySetParams.RSSTDR"
          :label="$t('training_builder.text_input.rest_time_after_set')"
          variable="RSSTDR"
          @input="handleDurationInput"
        />
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NUMGC"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_ground_contacts.title')"
            :placeholder="$t('label.e_g') + ' ' + 2"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.JMHGT"
            outlined
            dense
            :label="$t('training_builder.text_input.jump_height.title')"
            :placeholder="$t('label.e_g') + ' ' + '0,8'"
            :decimal-precision="2"
            suffix="m"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NumberInput from '@/components/helpers/NumberInput.vue'
import { cloneVariables } from '@/components/training-builder/helpers'
import MinuteSecondInput from '@/components/helpers/MinuteSecondInput.vue'

export default {
  name: 'PlyometricsParamsEntry',
  components: { MinuteSecondInput, NumberInput },
  props: {
    exercise: {
      type: Object,
      required: true
    },
    setParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dirtySetParams: cloneVariables(this.setParams)
    }
  },
  watch: {
    dirtySetParams: {
      deep: true,
      handler: function (newValue) {
        this.$emit('update:setParams', newValue)
      }
    }
  },
  methods: {
    checkIfParamExists(param) {
      if (!this.exercise.tags) return false

      return this.exercise.tags.some(t => t.tag_id === 'params' && t.value === param)
    },
    handleDurationInput(min, sec, variable) {
      this.dirtySetParams[variable] = min * 60 + sec > 0 ? min * 60 + sec : null
    }
  }
}
</script>
